/**
 * Panel có animation mount/unmount — fade/slide theo prop isOpen.
 */
import { useEffect, useState } from 'react';

export const AnimatedPanel = ({
  isOpen,
  className = '',
  children,
  ...rest
}) => {
  const [mounted, setMounted] = useState(isOpen);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setMounted(true);
      return undefined;
    }

    setVisible(false);
    return undefined;
  }, [isOpen]);

  useEffect(() => {
    if (!mounted || !isOpen) {
      return undefined;
    }

    const frame = window.requestAnimationFrame(() => {
      setVisible(true);
    });

    return () => window.cancelAnimationFrame(frame);
  }, [mounted, isOpen]);

  const handleTransitionEnd = (event) => {
    if (event.currentTarget !== event.target) {
      return;
    }

    if (!visible && !isOpen) {
      setMounted(false);
    }
  };

  if (!mounted) {
    return null;
  }

  return (
    <div
      className={`animated-panel ${visible ? 'is-visible' : ''} ${className}`.trim()}
      onTransitionEnd={handleTransitionEnd}
      {...rest}
    >
      {children}
    </div>
  );
};
